<template>
        <span v-if="!editable">{{value}}</span>
        <input v-else v-bind:value="value"
                      v-on:input="$emit('input', $event.target.value)">
</template>

<script>
  export default {
    name: "EditableString",
    props: {editable : Boolean,
            value: String}
  }
</script>

<style scoped>
</style>
